<template>
  <b-alert class="email-not-verified-alert" variant="danger" show>
    <p>
      {{ $t("components.shared.email_not_verified_alert.content") }}
    </p>
    <b-row>
      <b-col md="auto">
        {{ $t("components.shared.email_not_verified_alert.call_to_action") }}
      </b-col>
      <b-col class="text-right">
        <b-button to="/profile/account">{{
          $t("components.shared.email_not_verified_alert.button")
        }}</b-button>
      </b-col>
    </b-row>
  </b-alert>
</template>

<script>
export default {
  name: "EmailNotVerifiedAlert",
};
</script>

<style lang="scss"></style>
